import axios from 'axios';
import qs from 'qs';
import { getBaseUrl } from './config';
import { EXPRESS_INFO } from "./keys";
import { sort_ASCII } from "../util/util";
import md5 from 'js-md5'
import { Toast } from "vant";

axios.defaults.withCredentials=false
const host = window.location.host,protocol= window.location.protocol;
const service = axios.create({
    baseURL: getBaseUrl(),
    withCredentials: false,
    // baseURL: `${protocol}//${host}/api`,
    timeout: 30000, // request timeout
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})
service.interceptors.request.use(function(config) {
    if (JSON.parse(sessionStorage.getItem("EXPRESS_INFO") || "{}").expressToken) {
        config.headers.common["Express-Token"] = JSON.parse(sessionStorage.getItem("EXPRESS_INFO") || "{}").expressToken
    }
    if (config.params && (config.params instanceof Object) && !config.params.sign) {
        config.params["sign"] = md5(decodeURIComponent(sort_ASCII(config.params) + "yx_2020_express_dl"))
    }
    const params = config.data ? qs.parse(config.data) : {}
    if (params && !params.sign) {
        const params = qs.parse(config.data)
        config.data = qs.stringify({
            ...params,
            sign: md5(decodeURIComponent(sort_ASCII(params) + "yx_2020_express_dl"))
        })
    }
    return Promise.resolve(config);
}, function(error) {
    Toast('系统开小差了，刷新后再试')
    return Promise.reject(error);
})

service.interceptors.response.use(function(response) {
    let retData
    if (response.data.code === 100007) {
        retData = {
            ...response.data,
            message: '系统开小差了，刷新后再试'
        }
    } else {
        retData = {
            ...response.data
        }
    }
    return Promise.resolve(retData);
}, function (error) {
    Toast('系统开小差了，刷新后再试')
    return Promise.reject(error);
})

class CRMAxios{
    constructor(options = {}) {
        this.options = options;
    }
    request(options) {
        return service.request(options);
    }
    get(url, options = {}) {
        return this.request({
            url: url,
            params: {
                ...options
            }
        })
    }
    post(url, data, options = {}) {
        if (data instanceof Object) {
            data = qs.stringify(data);
        }
        return this.request({
            method: 'post',
            url,
            data,
            ...options
        });
    }
}
const instanceAxios = new CRMAxios();
export const request = instanceAxios.request.bind(instanceAxios);
export const get = instanceAxios.get.bind(instanceAxios);
export const post = instanceAxios.post.bind(instanceAxios);

